import React from 'react'
import { FullScreenLoader } from '../Shared/Loading'

export default function Homepage() {
  return <FullScreenLoader />
}
